<script lang="ts">
  import AttachmentIcon from "../AttachmentIcon.svelte";

  export let s;
  export let files: FileList | null = null;

  function resetInput(e: Event) {
    files = null;
    if (e.target && e.target instanceof HTMLInputElement) {
      e.target.value = "";
    }
  }
</script>

<label for="tv-file-attachment">
  <div class={s.attachmentIcon}>
    <AttachmentIcon />
  </div>
</label>

<input
  class={s.hiddenInput}
  id="tv-file-attachment"
  type="file"
  accept="image/png,image/gif,image/jpeg"
  bind:files
/>
